import DatePicker from 'vue2-datepicker';
import Export from "@/components/Export/Export.vue";
import logger from "vuex/dist/logger";
import pagination from "@/components/__new_ui_kit/Pagination/Pagination";
import NoData from "@/components/__new_ui_kit/Table/NoData";
import Vue from "vue";

export default Vue.extend({
    components: {
      DatePicker, Export, logger, pagination, NoData
    },
    data () {
        return {
            isReloadStart: false,
            activePage: 1,
            showQuantity: 9,
            showLinesStart: 1,
            disabledPrev: true,
            disabledNext: false,
            firstData:[],
            defaultLines: [],
            apiData:[],
            // lines: [
            //     {id: 1, status: null, date: 1}
            // ],
            date:null,
            firstDate:'',
            lastDate:'',
            tdReload: true,
            name: 'thbf',
            jsonData: [],
            dataFile: 'users.csv',
            labels: {
                fname: 'First Name',
                lname: 'Last Name'
            },
            fields : ['id','date', 'result', 'facebook', 'instagram', 'twitter', 'tiktok', 'youtube', 'email', 'sms', 'telegram', /*'messengers'*/],
            isExported: false,
            dataContent:[],
            serializeDataExport:'',
            newArr:[],
            anim: false,
            reloadAnim: false,
            counterNetworks: {},
            counter: 0,
            page_url: '',
            tag_1: '',
            tag_2: '',
            // isEmptyData: true,
        }
    },
    props: ['lines'],
    computed: {
        showLines: function() { //determine which lines to show
            this.lines.forEach((item, index) => {
                if (this.lines[index] && item.networks) {
                    this.lines[index].networks = item.networks.filter(this.onlyUnique)
                }
            })
            return this.lines.slice(this.showLinesStart - 1, this.showLinesFinish)
        },
        pages: function() {  // keep track of the number of pages
            return Math.ceil(this.lines.length/this.showQuantity)
        },
        pagesArray: function() { //an array of pages in the navigation bar
            let arr = []
            for(let i = 0;i<this.pages;i+=1) {
                arr.push(i)
            }
            return arr
        },
        isEmptyData() {
            let isEmpty = true;
            this.lines.forEach(item => {
                if (item.networks) {
                    if (item.networks.length) {
                        isEmpty = false;
                    }
                }
            });
            return isEmpty;
        }
    },
    methods: {
        getFullURL() {
            return process.env.VUE_APP_URL + '/' + this.page_url;
        },
        getCustomUrl() {
            return process.env.VUE_APP_URL + '/' + this.tag_1 + '/' + this.tag_2
        },
        // async loadingDataContent() {  //get data for graphs and structure (active data from social networks)
        //     return new Promise((resolve, reject) => {
        //         const id = this.$route.params.id
        //         this.$store.dispatch('contentById', {id, full: true, non_edit: true})
        //             .then(
        //                 resp => {
        //                     for (let i = 0;i < resp.data.steps.length;i+=1) {
        //                         this.dataContent.push(resp.data.steps[i])
        //                     }
        //                     const visits = resp.data.visits
        //                     this.page_url = resp.data.page_url
        //                     this.tag_1 = resp.data.tag_1
        //                     this.tag_2 = resp.data.tag_2
        //                     let countSuccess = 0
        //                     let allDate = []
        //                     visits.map(visit => {
        //                         let date = new Date(visit.created_at)
        //                         if (visit.result) {
        //                             countSuccess++
        //                         }
        //                         allDate.push({date, success: visit.result ?? false})
        //                     })
        //                     resolve(allDate)
        //                     this.stat = [visits.length - countSuccess, countSuccess]
        //                     this.lines = resp.data.visits
        //                     return new Promise((resolve, reject) => {
        //                         resolve(this.jsonData = this.lines)
        //                         //reject(console.log('test'))
        //                     })
        //                 }
        //             )
        //     })
        // },
        // testReload() {
        //     this.$emit('render');
        //     this.requestSubscribers();
        // },
        // requestSubscribers(){
        //     this.baseSettings();
        //     this.isReloadStart = true;
        //     this.loadingDataContent().then(() => {
        //         this.tdReload = false;
        //         this.isReloadStart = false;
        //     });
        // },
        baseSettings() {
            this.newArr = []
            this.navigate(0)
            this.activePage = 1
            this.tdReload = true
        },
        navigate: function(ind) {//navigation(page switching)
            this.activePage = ind
            /*this.activePage = ind + 1
            this.disabledPrev = this.activePage < 2
            this.disabledNext = this.activePage > this.pages - 1
            if (this.activePage>this.pages-1) { this.activePage = this.pages }
            this.showLinesStart =  ind > 0 ? (ind) * this.showQuantity + 1 : 1*/
            this.showLinesFinish =  ind > 0 ? (ind) * this.showQuantity + this.showQuantity : this.showQuantity
        },
        convertDate: function(arg) { //convert date to MM-DD-YYYY format
            return arg.getFullYear() + '-' +
                  (arg.getMonth()<10?'0':'') +
                  (arg.getMonth()+1) + '-' +
                  (arg.getDate()<10?'0':'')+
                   arg.getDate()
        },
        handleChange: function() {
            this.defaultLines = this.jsonData
            this.firstDate = this.convertDate(this.date[0])
            this.lastDate = this.convertDate(this.date[1])
            this.lines = this.defaultLines.filter(defaultLine => (defaultLine.created_at||'').split('T')[0] >= this.firstDate && (defaultLine.created_at||'').split('T')[0] <= this.lastDate)
        },
        defaultDate: function() {    // discharge date
            this.lines = this.jsonData
        },
        exported() { //export CSV
            return new Promise((resolve)=>{
                resolve(this.isExported = true)
            }).then(()=>{
                this.isExported = false
            }).catch((err)=>{
                console.log(err)
            })
        },
        filtering(social, arr, all = false) {    //presence of a social network in the project
            let filterSocial = arr.filter(val=>this.getValidType(val, all) === social && val.status)
            return Boolean(filterSocial.length)
        },
        getValidType(item, all = false) {
            if (item.icon === 'messenger' && !all) {
                return item.check.inputs[0].account;
            } else {
                return item.icon;
            }
        },
        onlyUnique(value, index, self) {
            let id = value['visitor_id'] + '_' + value.user + '_' + value.type
            // select unique account
            let res = '';
            if (self[self.indexOf(value) - 1]) {
                res = (!(this.counterNetworks[id])) ? value.user : '';
            } else {
                res = value.user;
            }
            // calculate count of proved accounts
            if (self.indexOf(value) === index) {
                if (this.counterNetworks[id]) {
                    this.counterNetworks[id] += 1
                } else {
                    this.counterNetworks[id] = 1
                }
            } else {
                this.counterNetworks[id] = 1
            }
            return res;
        },
        parseNetworks(item, name) {
            if (item.networks) {
                let items = item.networks.filter(v=>v.type === name)
                return items;
            }

        },

        isEmail(val) {
            let regexQuery = "^\\w+([\\+.-]?\\w+)*@\\w+([\\.-]?\\w+)*(\\.\\w{2,3})+$"
            let email = new RegExp(regexQuery, "i")
            return email.test(val)
        },

        youTubeParser(account, type) {
            let checkerAccount = this.isEmail(account)
            if (type === 'channel' && !checkerAccount) {
                return account
            }
            if (type === 'account' && checkerAccount) {
                return account
            }
        },
        linkParser(type, account_id) {
            let socialSubLink;
            switch(type) {
                case 'facebook':
                    socialSubLink = "https://facebook.com/";
                    break;
                case 'instagram':
                    socialSubLink = "https://instagram.com/";
                    break;
                case 'twitter':
                    socialSubLink = "https://x.com/";
                    break;
                case 'youtube':
                    socialSubLink = "https://youtube.com/channel/";
                    break;
                case 'tiktok':
                    socialSubLink = "https://tiktok.com/";
                    break;
            }

            let isLink = true;
            let account = account_id;
            if (type === 'youtube') {
                if (account && this.youTubeParser(account, 'account')) {
                    isLink = false;
                }
            }

            if (isLink) {
                account = socialSubLink + account;
            }

            return account

        },
        getCount(userId, name, type) {
            let id = userId + '_' + name + '_' + type
            return (this.counterNetworks[id]) ? this.counterNetworks[id] : 0
        },
        convertStatus(status) { // convert status for export CSV
           return status !== null ? 'success' : 'failured'
        },
        convertSocial(arr, social) { // convert social for export CSV
            if (arr.length > 0) {
                let socialArr = arr.filter(element=>element.type.toLowerCase() === social)
                let socialSubLink = '';
                // added link
                switch(social) {
                    case 'facebook':
                        socialSubLink = "https://facebook.com/";
                        break;
                    case 'instagram':
                        socialSubLink = "https://instagram.com/";
                        break;
                    case 'twitter':
                        socialSubLink = "https://x.com/";
                        break;
                    case 'youtube':
                        socialSubLink = "https://youtube.com/channel/";
                        break;
                    case 'tiktok':
                        socialSubLink = "https://tiktok.com/";
                        break;
                }
                let result = '';
                if (socialArr.length) {
                    socialArr.forEach((item, index) => {
                        let account = item.user;
                        let isLink = true;

                        if (social === 'youtube') {
                            if ((account) && this.youTubeParser(account, 'account')) {
                                isLink = false;
                            }
                        }

                        if (isLink) {
                            account = (account) ? socialSubLink + account : '-';
                        }

                        // if (index === (socialArr.length - 1)) {
                            result = account;
                        // } else {
                        //     result += account + ' | ';
                        // }
                    })
                }
                return result ? result : '-'
            }
            return '-'
        },
        serializeDataExportFoo() { // convert structure for export CSV
            this.serializeDataExport = this.jsonData
            return new Promise((resolve) => {
                resolve(this.anim = true)
            })
                .then(() => {
                    let tmp = [];
                    let index = 0;
                    for (let i = 0; i < this.jsonData.length; i += 1) {
                        // debugger; // DEBUGGER
                        let networks = this.jsonData[i].networks
                        let innerObj = {};

                        networks.forEach((item, key) => {
                            innerObj.id = this.jsonData[i].id;
                            innerObj.date = this.jsonData[i].created_at.split('T')[0]
                            innerObj.result = this.convertStatus(this.jsonData[i].result)
                            innerObj[networks[key].type.toLowerCase()] = networks[key].user;

                            if (key > 0) {
                                let types = []
                                if (tmp[index]) {
                                    types = Object.keys(tmp[index]);
                                    // console.log('saver:', tmp[index]);
                                }
                                // console.log('index:', index);
                                // console.log('types: ', types);
                                // console.log('type:', networks[key].type.toLowerCase());

                                if (types.length && types.includes(networks[key].type.toLowerCase())) {
                                    innerObj = {}
                                    innerObj.id = this.jsonData[i].id;
                                    innerObj.date = this.jsonData[i].created_at.split('T')[0]
                                    innerObj.result = this.convertStatus(this.jsonData[i].result)
                                    innerObj[networks[key].type.toLowerCase()] = networks[key].user;
                                    console.log(innerObj);
                                    index += 1;
                                    tmp[index] = Object.assign({}, innerObj);
                                    // innerObj = {}
                                } else {
                                    tmp[index] = Object.assign({}, innerObj);
                                }
                            } else {
                                tmp[index] = Object.assign({}, innerObj);
                            }
                            console.log(tmp);
                        })
                        index++;
                    }

                    index = 0;
                    tmp.forEach(item => {

                        this.newArr.push({
                            id: item.id,
                            date: item.date,
                            result: this.convertStatus(item.result),
                            facebook: (item.hasOwnProperty('facebook')) ? this.linkParser('facebook', item.facebook) : '-',
                            instagram: (item.hasOwnProperty('instagram')) ? this.linkParser('instagram', item.instagram) : '-',
                            twitter: (item.hasOwnProperty('twitter')) ? this.linkParser('twitter', item.twitter) : '-',
                            tiktok: (item.hasOwnProperty('tiktok')) ? this.linkParser('tiktok', item.tiktok) : '-',
                            youtube: (item.hasOwnProperty('youtube')) ? this.linkParser('youtube', item.youtube) : '-',
                            email: (item.hasOwnProperty('email')) ? item.email : '-',
                            sms: (item.hasOwnProperty('sms')) ? item.sms : '-',
                            telegram: (item.hasOwnProperty('telegram')) ? item.telegram : '-',
                            // messengers: (item.hasOwnProperty('messengers')) ? item.messengers : '-',
                        })
                    })
                })
                .then(() => {
                    setTimeout(() => {
                        this.anim = false
                    }, 2000)
                })
        }
    },
    created() {
        // this.requestSubscribers()
        // this.loadingDataContent()
    },
})
